import IGenericResult from "../interfaces/IGenericResult";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";
class ConcessionariaService {
    async update(data: any) {
        return await api.put<any>(`${resources.concessionaria}/Update`, data);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.concessionaria}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getConcessionarias() {
        return await api.get<IGenericResult[]>(`${resources.concessionaria}/GetAllConcessionarias`);
    }
}

export default new ConcessionariaService();
